import { i18n } from "../../../boot/i18n";
import { store } from "../../../store";

// All employees can view lead times; only admins and purchasers can edit.
const viewAuth = () =>
  Boolean(store.state.main.user && store.state.main.user.isEmployee);
const editAuth = () =>
  store.state.main.user &&
  (store.state.main.user.hasRole("purchaser") || store.state.main.user.isAdmin);

export default {
  routes: [
    {
      name: "lead-times",
      path: "lead-times",
      meta: {
        icon: "lead_time",
        title: i18n.global.tc("Lead Time", 0),
        auth: viewAuth,
        crumbs: ["sales-tools"],
      },
      component: () => import("pages/employee/LeadTimes"),
    },
  ],

  dialogs: [
    {
      name: "lead-time-edit",
      path: "/lead-times/:leadTimeID/edit",
      meta: { auth: editAuth },
      component: () => import("../../../dialogs/employee/LeadTimeEdit"),
    },
  ],
};
